var render = function () {
  var _this = this;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.editable ? _c('label', {
    staticClass: "custom-file-upload",
    class: _vm.$style.pictureUploadLabel
  }, [_c('input', {
    ref: "inputPictureUpload",
    attrs: {
      "type": "file",
      "name": "img",
      "accept": "image/x-png,image/gif,image/jpeg,image/png"
    },
    on: {
      "change": _vm.previewImage
    }
  }), _c('MottoIcon', {
    class: _vm.$style.penIcon,
    attrs: {
      "name": "PenToSquare",
      "color": "primary"
    }
  })], 1) : _vm._e(), _c('b-modal', {
    attrs: {
      "id": "previewPictureUpload",
      "modal-class": "modal-picture-upload",
      "hide-footer": "",
      "centered": true
    },
    on: {
      "hide": _vm.clearFields
    }
  }, [!_vm.imageLoaded || _vm.error ? _c('LoaderIcon', {
    staticClass: "m-auto",
    attrs: {
      "error": _vm.error,
      "error-message": _vm.errorMessage
    }
  }) : _vm._e(), _vm.imageLoaded ? _c('div', {
    class: _vm.$style.previewContainer
  }, [_c('div', {
    class: _vm.$style.cropContainer
  }, [_c('div', {
    class: _vm.$style.previewTitle
  }, [_c('h2', [_vm._v("Crop Image")])]), _c('div', [_c('Cropper', {
    ref: "cropper",
    staticClass: "motto-cropper",
    attrs: {
      "background-class": "motto-cropper__background",
      "foreground-class": "motto-cropper__foreground",
      "image-restriction": "stencil",
      "resize-image": {
        wheel: false
      },
      "stencil-size": _vm.stencilSize,
      "stencil-props": {
        lines: {},
        handlers: {},
        movable: false,
        scalable: false,
        aspectRatio: 1,
        previewClass: 'motto-cropper__stencil'
      },
      "transitions": false,
      "debounce": false,
      "default-size": _vm.defaultSize,
      "min-width": 150,
      "min-height": 150,
      "src": _vm.imagePreviewPath
    },
    on: {
      "change": _vm.onChange
    }
  }), _c('CropZoomResizer', {
    attrs: {
      "zoom": _vm.zoom
    },
    on: {
      "change": _vm.onZoom
    }
  })], 1)]), _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('div', {
    class: [_vm.$style.previewTitle, _vm.isMobile ? '' : 'ml-20']
  }, [_c('h2', [_vm._v("Preview")])]), _c('div', {
    class: _vm.$style.previewColumn
  }, [_c('div', {
    class: _vm.$style.previewPictureWrapper
  }, [_c('Preview', {
    attrs: {
      "height": _vm.isMobile ? 150 : 200,
      "width": _vm.isMobile ? 150 : 200,
      "image": _vm.previewImageResult.image,
      "coordinates": _vm.previewImageResult.coordinates
    }
  })], 1), _c('div', {
    class: _vm.$style.submitButtonsContainer
  }, [_c('BaseButton', {
    attrs: {
      "disabled": _vm.isSubmitting,
      "theme": "red"
    },
    on: {
      "click": function click() {
        return _this.$bvModal.hide('previewPictureUpload');
      }
    }
  }, [_c('p', {
    staticClass: "button-text color-white"
  }, [_vm._v("Discard")])]), _c('BaseButton', {
    attrs: {
      "disabled": _vm.isSubmitting,
      "theme": "blue"
    },
    on: {
      "click": _vm.submitPicture
    }
  }, [_vm.isSubmitting ? _c('LoaderIcon') : _c('p', {
    staticClass: "button-text color-white"
  }, [_vm._v("Submit")])], 1)], 1)])])]) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }